
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import BiSectionPage from "@/report/pages/BiSectionPage.vue"

@Component({name: "InsurancePage", components: {BiSectionPage}})
export default class InsurancePage extends AbstractPage {}
